export default "__VITE_ASSET__jh3VLHzL__"